import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';

import { CelumDialog } from '../../model/celum-dialog';
import { StandardDialogConfiguration } from '../../model/standard-dialog-configuration';
import { Dialog } from '../base-dialog/dialog';
import { DialogContent } from '../base-dialog/dialog-content';
import { DialogError } from '../base-dialog/dialog-error';
import { buttonType, DialogFooter } from '../base-dialog/dialog-footer';
import { DialogHeader } from '../base-dialog/dialog-header';

@Component({
  selector: 'celum-standard-dialog',
  templateUrl: './standard-dialog.html',
  imports: [DialogContent, TranslatePipe, Dialog, DialogError, DialogFooter, DialogHeader],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StandardDialog implements CelumDialog<StandardDialogConfiguration>, OnChanges {
  @Input() public color: string;
  @Input() public cancelBtnText = 'COMMON.CANCEL';
  @Input() public confirmBtnText = 'COMMON.OK';
  @Input() public buttons: buttonType[] = ['ok', 'cancel'];
  @Input() public disableOnCancelClosing = false;
  @Input() public disableOnConfirmClosing = false;
  @Input() public disableOnEnterConfirmation = false;
  @Input() public headerText = '';
  @Input() public message = '';
  @Input() public valid = true;
  @Input() public errors: any[] = [];
  @Input() public loading = false;
  @Input() public disableBackdropClose = false;
  // if true, prevents from having button able to close all opened dialogs
  @Input() public hideCloseAllBtn = false;

  @Output() public readonly onCancel = new EventEmitter();
  @Output() public readonly onCloseAll = new EventEmitter();
  @Output() public readonly onConfirm = new EventEmitter();

  constructor(private dialogRef: MatDialogRef<StandardDialog>) {}

  public ngOnChanges({ disableBackdropClose }: SimpleChanges): void {
    if (disableBackdropClose) {
      this.dialogRef.disableClose = this.disableBackdropClose;
    }
  }

  public cancel(event: any): void {
    this.onCancel.emit(event);
    if (!this.disableOnCancelClosing) {
      this.dialogRef.close(false);
    }
  }

  public closeAll(event: any): void {
    this.onCloseAll.emit(event);
    if (!this.disableOnCancelClosing) {
      this.dialogRef.close(false);
    }
  }

  public confirm(event: any): void {
    this.onConfirm.emit(event);
    if (!this.disableOnConfirmClosing) {
      this.dialogRef.close(true);
    }
  }

  public configure(config: StandardDialogConfiguration): void {
    const { cancelBtnText, confirmBtnText, color, headerText, message } = config;
    this.headerText = headerText;
    this.message = message;
    cancelBtnText && (this.cancelBtnText = cancelBtnText);
    confirmBtnText && (this.confirmBtnText = confirmBtnText);
    color && (this.color = color);
  }
}
